export default class AccountSlider {
  constructor(component) {
    this.dom = {
      $component: component,
      $accountSlider: component,
      $accountSliderBtn: document.querySelector('.js-accountBtn'),
      $accountSliderToggle: document.querySelectorAll('.js-accountSliderToggle'),
      $accountSliderUnderlay: document.querySelector('.js-accountSliderUnderlay'),
      $navigation: document.querySelector('.js-navigation'),
    }
    this.state = {
      accountSliderOpen: false,
      accountSliderOpenClass: 'openAccountSlider',
      underlayActiveClass: 'isActive',
    }
    this.accountSliderToggleHandler = this.accountSliderToggle.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    dom.$accountSliderToggle.forEach($toggle => $toggle.addEventListener('click', this.accountSliderToggleHandler))
  }

  accountSliderToggle() {
    const { dom, state } = this
    // Import the GlobaleSlider class
    const globaleSlider = window.theme.GlobaleSlider

    if (state.accountSliderOpen) {
      dom.$accountSlider.setAttribute('aria-hidden', 'true')
      dom.$accountSlider.setAttribute('aria-expanded', 'false')
      dom.$navigation.classList.remove(state.accountSliderOpenClass)
      dom.$accountSliderBtn.classList.remove(state.accountSliderOpenClass)
      dom.$accountSliderUnderlay.classList.remove(state.underlayActiveClass)
      state.accountSliderOpen = false
    } else {
      // Close the GlobaleSlider if it's open
      if (globaleSlider && globaleSlider.state.globaleSliderOpen) {
        globaleSlider.globaleSliderToggle()
      }
      dom.$accountSlider.setAttribute('aria-hidden', 'false')
      dom.$accountSlider.setAttribute('aria-expanded', 'true')
      dom.$navigation.classList.add(state.accountSliderOpenClass)
      dom.$accountSliderBtn.classList.add(state.accountSliderOpenClass)
      dom.$accountSliderUnderlay.classList.add(state.underlayActiveClass)
      state.accountSliderOpen = true
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.AccountSlider = this
  }
}
